import clsx from 'clsx';
import { ChangeEvent, FC } from 'react';
import Button from '../Button/Button';

interface Props {
  label?: string;
  value: number | string;
  width: string;
  classNameLabel?: string;
  classNameInput?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  type?: 'text' | 'number' | 'email' | 'password';
  placeholder?: string;
  icon?: React.ReactNode;
  ctaText?: string;
  ctaAction?: () => void;
}

const Input: FC<Props> = ({
  value,
  width,
  onChange,
  label,
  classNameLabel,
  classNameInput,
  type = 'text',
  placeholder,
  icon,
  ctaText,
  ctaAction,
  ...rest
}) => {
  return (
    <label
      className={clsx('relative', width, classNameLabel)}
      data-testid="input-container"
    >
      {label && <p className="mb-1">{label}</p>}
      {icon && (
        <div className="absolute left-3 bottom-3" data-testid="input-icon">
          {icon}
        </div>
      )}
      <input
        placeholder={placeholder}
        type={type}
        value={value}
        aria-label={label}
        onChange={e => onChange(e)}
        className={clsx(
          'h-12 border-2 rounded-md leading-[48px]',
          width,
          icon ? 'pl-12' : 'pl-4',
          classNameInput
        )}
        data-testid="input"
        {...rest}
      />
      {ctaAction && ctaText && (
        <div className="absolute right-1 top-1">
          <Button type="input" size="small" onClick={ctaAction}>
            {ctaText}
          </Button>
        </div>
      )}
    </label>
  );
};

export default Input;
